import { render, staticRenderFns } from "./CardInstallments.vue?vue&type=template&id=67c8f3a1&scoped=true"
import script from "./CardInstallments.vue?vue&type=script&lang=js"
export * from "./CardInstallments.vue?vue&type=script&lang=js"
import style0 from "./CardInstallments.vue?vue&type=style&index=0&id=67c8f3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8f3a1",
  null
  
)

export default component.exports